import styled from "styled-components";

export const Form = styled.form`
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 20px;

    .col1 {
        grid-column: span 1 / span 1;
    }
    .col2 {
        grid-column: span 2 / span 2;
    }
    .col3 {
        grid-column: span 3 / span 3;
    }
    .col4 {
        grid-column: span 4 / span 4;
    }
    .col5 {
        grid-column: span 5 / span 5;
    }
    .col6 {
        grid-column: span 6 / span 6;
    }

    @media (max-width: 767px) {
        .col1, .col2, .col3 {
            grid-column: span 3 / span 3;
        }
    }

    @media (max-width: 600px) {
        .col1, .col2, .col3, .col4, .col5, .col6 {
            grid-column: span 6 / span 6;
        }
    }
`;

export const LabelWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
`;

export const Label = styled.label`
    display: flex;
    margin-bottom: 5px;
`;

export const LabelAction = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;
    font-size: 12px;
    color: var(--theme-color-primary);
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 5px;

    svg {
        width: 14px;
        height: auto;
    }
`;

export const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 10px;
    /* transform: translateY(-8px); */
`;

export const ActionsContainers = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: end;
    gap: 10px;
    /* transform: translateY(-70px); */
`;


export const FormError = styled.p`
    color: var(--color-error);
    font-size: 11px;
    padding-top: 2px;
`;